export function getComponentDisplayName(component) {
  return (component.type && component.type.displayName) || '';
}

function toArray(element) {
  if (!element) return [];
  return element.findIndex ? element : [element];
}

function getChildren(component) {
  return toArray(component.props && component.props.children);
}

export function findComponentsByType(component, type) {
  return toArray(component)
    .map(childComponent => {
      let allChildComponents = [];
      if (getComponentDisplayName(childComponent) === type) {
        allChildComponents.push(childComponent);
      }
      const childComponents = getChildren(childComponent)
        .map(child => findComponentsByType(child, type))
        .filter(foundChildren => foundChildren && foundChildren.length)
        .reduce((flatComps, comp) => [...flatComps, ...comp], []);

      allChildComponents = allChildComponents.concat(childComponents);
      return allChildComponents;
    })
    .reduce((flatComps, comp) => [...flatComps, ...comp], []);
}
